import React, { ReactNode } from "react";

import { fieldCannotBeEmpty } from "constants/messages";

import { FieldValues, RegisterOptions } from "react-hook-form";

import {
  FormControl,
  FormHelperText,
  Input,
  Stack,
  useTheme,
  Slider,
  Typography,
  type InputProps,
} from "@mui/material";
import { type SxProps } from "@mui/material";

import { FieldProps } from "./types";

// import { Slider } from '@repo/ui'

const RadiusFieldImpl = ({
  watch,
  fieldName,
  label = "",
  placeholder,
  register,
  setValue,
  formState: { errors },
  options,
  defaultValue = "12",
  validation = {
    required: fieldCannotBeEmpty,
  },
}: FieldProps) => {
  const theme = useTheme();

  const currentBorderRadius = watch(fieldName) || defaultValue;

  return (
    <FormControl
      name={fieldName}
      // error={!!errors[name]}
      // control={control}
    >
      {label && (
        <Typography mb="8px" variant="body3">
          {label}
        </Typography>
      )}
      <Slider
        color={theme.palette.primary[950]}
        step={4}
        // valueLabelDisplay="auto"
        shiftStep={8}
        defaultValue={parseInt(currentBorderRadius)}
        min={0}
        max={24}
        marks
        onChange={(e, newValue) => {
          setValue(fieldName as string, newValue);
        }}
      />
      <Stack direction="row" justifyContent="space-between">
        <Typography mb="8px" variant="body3" color="text.secondary">
          Sharp
        </Typography>
        <Typography mb="8px" variant="body3" color="text.secondary">
          Rounded
        </Typography>
      </Stack>
    </FormControl>
  );
};

/**
 * Re-exported under the generic signature so a caller's own form type flows through.
 * See the `FieldProps` docblock in `./types` for why the implementation above stays on the
 * default instantiation and why this assertion is the standard idiom rather than a
 * suppression.
 */
export const RadiusField = RadiusFieldImpl as <T extends FieldValues = FieldValues>(
  props: FieldProps<T>,
) => React.ReactElement | null
